module.exports = __webpack_public_path__ + "img/image_gateway_f460.ccb291be.svg";